import React from 'react';
import RoomPage from './RoomPage';

function Home() {
  return <RoomPage roomId={1} />;
}

export default Home;
